import './index.scss'

import { renderHtml, bindEvent, onReady, submitUserChoose } from './dom';
import fetchData from './fetchData';
import { isNeedShowModal } from "./cookie"
import { isWebView } from "./platform"
/**
 * 1.获取cookie判断是否需要展示弹窗
 * 2.获取对应语言展示数据，调用revamp接口
 * 3.数据获取成功，展示弹窗(是否需要回填用户上一次的选择)
 * 4.事件绑定
 */

onReady(() => {
    if (window.__CONSENT_INIT__) {
       return; 
    }

    window.__CONSENT_INIT__ = true
    if (isNeedShowModal()) {
        fetchData((data) => {
            if (isWebView()) {
                // 小程序和app中不需要弹窗，默认同意全部
                submitUserChoose(data)
            } else  {
                // 渲染弹窗
                renderHtml(data)
                // 事件绑定
                bindEvent(data)
            }
            
        })
    }
})
